(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  new Swiper('.clinical-slider .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-with-accordion"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  // Accordion title click = toggle learn more section (same as learn more)
$(document).on('click', '.accordion-title', function (e) {
  e.preventDefault();

  var $item = $(this).closest('.accordion-item');
  var $panel = $(this).closest('.tab-panel');
  var $moreText = $item.find('.more-text').first();

  // Agar is item me learn more content hi nahi hai -> kuch mat karo
  if (!$moreText.length) return;

  if ($moreText.is(':visible')) {
    $moreText.stop(true, true).slideUp(300);
    $item.removeClass('is-expanded');
  } else {
    $panel.find('.more-text').stop(true, true).slideUp(300);
    $panel.find('.accordion-item').removeClass('is-expanded');

    $moreText.stop(true, true).slideDown(300);
    $item.addClass('is-expanded');

    // ✅ Same function call as learn more
    updateRightImageAndLink($item);
  }
});


  $('.accordion-content').hide();
  $('.more-text').hide();

  var $rightImage = $('.right-ingredient-image');
  var defaultImage = $rightImage.attr('src');

  function updateRightImageAndLink($item) {
    if (!$item || !$item.length) return;

    var img = $item.attr('data-image');
    var link = $item.attr('data-rating-link');

    // Image update
    if (img && img.length > 5) {
      $rightImage.attr('src', img);
    } else {
      $rightImage.attr('src', defaultImage);
    }

    // Rating link update
    if (link && link.length > 5) {
      $('.rating-link')
        .attr('href', link)
        .removeClass('is-disabled');
    } else {
      $('.rating-link')
        .attr('href', 'javascript:void(0)')
        .addClass('is-disabled');
    }
  }

  function openFirstIngredient($panel) {
    var $first = $panel.find('.accordion-item:has(.more-text)').first();
    if ($first.length) {
      $first.find('.more-text').show();
      $first.addClass('is-expanded');
      updateRightImageAndLink($first);
    }
  }

  openFirstIngredient($('.tab-panel:visible'));

  $('.tab-btn').on('click', function () {
    var tabId = $(this).data('tab');

    $('.tab-btn').removeClass('active');
    $(this).addClass('active');

    $('.tab-panel').stop(true, true).slideUp(300);

    var $activePanel = $('#' + tabId);
    $activePanel.stop(true, true).slideDown(300);

    $activePanel.find('.accordion-content, .more-text').hide();
    $activePanel.find('.accordion-item').removeClass('is-expanded');

    openFirstIngredient($activePanel);
  });

// Allow anchor links inside title
$(document).on('click', '.accordion-title a', function(e){
  e.stopPropagation();
});


  $('.learn-btn').on('click', function (e) {
    e.preventDefault();

    var $moreText = $(this).next('.more-text');
    var $panel = $(this).closest('.tab-panel');
    var $item = $(this).closest('.accordion-item');

    if ($moreText.is(':visible')) {
      $moreText.stop(true, true).slideUp(300);
      $item.removeClass('is-expanded');
    } else {
      $panel.find('.more-text').stop(true, true).slideUp(300);
      $panel.find('.accordion-item').removeClass('is-expanded');

      $moreText.stop(true, true).slideDown(300);
      $item.addClass('is-expanded');

      updateRightImageAndLink($item);
    }
  });

  $(document).on('click', '.read-less-btn', function (e) {
    e.preventDefault();
    var $more = $(this).closest('.more-text');
    $more.stop(true, true).slideUp(300);
    $more.closest('.accordion-item').removeClass('is-expanded');
  });

  $(document).on('click', '.rating-link.is-disabled', function(e){
    e.preventDefault();
  });

// Search accordion items across ALL tabs
$('.ingredient-search-input').on('input', function () {

  var query = $(this).val().toLowerCase().trim();

  // If search empty -> reset everything
  if (query === '') {
    $('.accordion-item').show();

    // Show only active tab again
    $('.tab-panel').hide();
    $('.tab-panel').first().show();

    $('.tab-btn').removeClass('active');
    $('.tab-btn').first().addClass('active');

    return;
  }

  var firstMatchTabId = null;

  // Hide all items first
  $('.accordion-item').hide();

  // Search in ALL items
  $('.accordion-item').each(function () {

    var title = $(this).find('.accordion-title').text().toLowerCase().trim();

    if (title.indexOf(query) > -1) {

      $(this).show();

      // Find which tab-panel this item belongs to
      var $panel = $(this).closest('.tab-panel');
      var panelId = $panel.attr('id');

      // Save first matched tab
      if (!firstMatchTabId) {
        firstMatchTabId = panelId;
      }
    }
  });

  // If match found -> open that tab
  if (firstMatchTabId) {

    $('.tab-panel').hide();
    $('#' + firstMatchTabId).show();

    $('.tab-btn').removeClass('active');
    $('.tab-btn[data-tab="' + firstMatchTabId + '"]').addClass('active');

  } else {
    // No match: hide all panels
    $('.tab-panel').hide();
  }

});



});




  } catch(e) { console.error(e); }
})();
})();
